"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraSelectionButton = void 0;
const React = require("react");
const react_1 = require("react");
const extraSelectionButtons_1 = require("../../../helpers/extraSelectionButtons");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const CircularIcon_1 = require("../../../../../../components/base/atoms/CircularIcon");
const colors_1 = require("../../../../../../types/colors");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const Img_1 = require("../../../../../../components/base/atoms/Img");
const constants_1 = require("../../../helpers/constants");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ExtraSelectionButton");
/**
 * Quick add ingredient button for an individual ingredient. This is basically a toggle on or off for adding an ingredient as an extra.
 */
const ExtraSelectionButton = ({ salesOrderItemBuilt, blueprintStockedProduct, addProduct, removeProducts }) => {
    // get base data we need to build component
    const { productBlueprint } = salesOrderItemBuilt;
    const { productAvailabilityMap } = productBlueprint;
    const { productId, retailPrice, spiciness } = blueprintStockedProduct;
    const availability = productAvailabilityMap.get(productId);
    const { canAdd, canRemove, isNeverExtra } = availability;
    // button states
    const buttonSelected = (0, extraSelectionButtons_1.blueprintStockedProductExtraSelectionButtonSelected)(salesOrderItemBuilt, blueprintStockedProduct);
    const buttonDisabled = (0, extraSelectionButtons_1.blueprintStockedProductExtraSelectionButtonDisabled)(salesOrderItemBuilt, blueprintStockedProduct);
    // set button text
    const buttonText = (0, extraSelectionButtons_1.getBlueprintStockedExtraSelectionButtonText)(salesOrderItemBuilt, blueprintStockedProduct);
    // states of ingredient
    const removable = buttonSelected && canRemove;
    // what happens when extra selection button is pressed
    const onClick = removable
        ? // remove on selection of this button's ingredient
            () => removeProducts([blueprintStockedProduct])
        : canAdd
            ? // add one selection of this button's ingredient
                () => addProduct(blueprintStockedProduct)
            : null;
    // if this ingredient is never and extra, and cannot be selected more than once or doesn't have a price to make it an extra then
    // there's no point in adding the button
    const canNeverBeSelectedMoreThanOnce = (0, react_1.useMemo)(() => productBlueprint.noExtraSelectionForProduct(productId), [productId]);
    if (isNeverExtra || canNeverBeSelectedMoreThanOnce || !retailPrice) {
        return null;
    }
    return (React.createElement("div", { className: css("") },
        React.createElement(Button_1.BlockButton, { variant: "secondary", onClick: onClick, disabled: buttonDisabled, className: css("button") },
            React.createElement("div", { className: css("buttonContent") },
                React.createElement(CircularIcon_1.default, { isActive: buttonSelected, 
                    // act as a toggle
                    name: buttonSelected ? "tick" : "", variant: buttonDisabled ? colors_1.TColorVariants.Disabled : colors_1.TColorVariants.Primary, size: standardSizes_1.TStandardSizes.ExtraSmall }),
                React.createElement("span", { className: css("buttonTitle") }, buttonText),
                spiciness > 0 && (React.createElement("div", { className: css("spiciness") }, [...Array(spiciness)].map((level, index) => (React.createElement(Img_1.Img, { key: `extra-spiciness-${index + 1}`, src: constants_1.spicinessImage, className: css("spiciness_image") }))))),
                typeof retailPrice === "number" && retailPrice > 0 && (React.createElement("span", null,
                    "+",
                    React.createElement(Currency_1.Currency, null, retailPrice)))))));
};
exports.ExtraSelectionButton = ExtraSelectionButton;
//# sourceMappingURL=index.js.map